import React from 'react';
import PropTypes from 'prop-types';
/* eslint no-unused-vars: [2, { "varsIgnorePattern": "[IconConstants]" }] */
import IconConstants from 'components/shared/icons/IconConstants';
import provideTranslations from 'decorators/provideTranslations';

@provideTranslations('Icons')
class TriangleIconContainer extends React.Component {
  render() {
    return <TriangleIcon {...this.props} />;
  }
}

class TriangleIcon extends React.Component {
  static propTypes = {
    color: PropTypes.string,
    size: PropTypes.number,
  };

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  static defaultProps = {
    color: IconConstants.YELLOW,
    size: 38,
  };

  render() {
    const { getString } = this.context;
    const { color, size } = this.props;

    return (
      <svg width={size} height="100%" viewBox="0 0 45 38" role="img" aria-label={getString('AA_Triangle_Icon_Desc')}>
        <title>{getString('AA_Triangle_Icon_Title')}</title>
        <desc>{getString('AA_Triangle_Icon_Desc')}</desc>
        <polygon
          role="presentation"
          stroke={color}
          strokeWidth="5"
          fill="none"
          points="22.5,5 40,35 5,35"
        />
      </svg>
    );
  }
}

export default TriangleIconContainer;
